import React from 'react';
import load_ic from '../../assets/images/load-ic.svg';
import check_ic from '../../assets/images/check-ic.svg';
import error_ic from '../../assets/images/red-close.svg';
import parse from "html-react-parser";

export const InterestCompleteModal = (props) => {

    return (
        <div className="popup-msg-wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div
                            className={`popup-msg ${props.response ? 'popup-msg' : props.load ? 'popup-msg' : 'popup-msg-error'}`}>
                            {
                                props.load && (
                                    <>
                                        <h5>{parse(props.orderPageText.processingEnquiry)}</h5>
                                        <img src={load_ic} alt="icon" className="load-ic"/>
                                    </>)
                            }
                            {
                                !props.load && (
                                    <>
                                        <h5>{props.response ?
                                            parse(props.orderPageText.thankYouForSubmission) :
                                            parse(props.orderPageText.processingError)} </h5>
                                        <img src={props.response ? check_ic : error_ic} alt="icon"/>
                                        <p>{props.response ?
                                            parse(props.orderPageText.responseAck) :
                                            (props.errorMessage.response &&
                                            props.errorMessage.response.data &&
                                            props.errorMessage.response.data.messageUser ?
                                                props.errorMessage.response.data.messageUser :
                                                props.errorMessage.toString())}  </p>
                                        <button className="btn" onClick={(e) => {
                                            e.preventDefault();
                                            props.closeModal()
                                        }}>{parse(props.orderPageText.okButtonText)}
                                        </button>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default InterestCompleteModal;